<template>
	<div class="phhomecc" id="phhomecca">
		<div class="videopop" v-if="popnos">
			<div class="videopopcont">
				<video controls autoplay :src="popcont"></video>
				<div class="el-icon-circle-close closevi" @click="pupclose()"></div>
			</div>
			
		</div>
		<el-backtop ></el-backtop>
		<div class="homecc-banner">
			<div class="bannerimg">
				<img @load="getimg()" :src="pcbanimg" />
			</div>
			<hpheader ></hpheader>
			<!-- <hpscorhea v-if="!socrollhea"></hpscorhea> -->
			<transition  enter-active-class="fadeInLeft">
				<div class="banner-foo" :class="chaece?'checse':''">
					<div class="babberfoo-hea">
						{{first_product_list['name']}}
					</div>
					<div class="babberfoo-foo">
						{{first_product_list['name_content']}}
					</div>
					<div class="babberfoo-but" @click="natdetailsto(bannproid)" :style="'background:' + $store.state.themeColor">
						{{redirmore}}
					</div>
				</div>
			</transition>
		</div>
		<div class="homecc-bigpro" v-for="(item,index) in senpcproductcont" :id="'id'+item.product_id">
			<div class="bigpro-hea" @click="natdetailsto(item.product_id)">
				<img :src="item.second_image" />
			</div>
			<div class="bigpro-foo" :class="{bigproim:true,bigproimter:item.mess1}">
<!--				<div class="bigprofoo-hea">-->
<!--					{{item.second_product_list.name}}-->
<!--				</div>-->
				<div class="bigprofoo-model">
					{{item.second_product_list.name}}
				</div>
				<div class="bigprofoo-hea">
					{{item.second_product_list.name_content}}
				</div>
				<div class="bigprofoo-but" @click="natdetailsto(item.product_id)" :style="'background:' + $store.state.themeColor" >
					{{redirmore}}
				</div>
			</div>
		</div>
		<div class="homecc-mainpro">
			<div class="mainpro-item" v-for="(item,index) in bigpcproductticont"  :id="'minid'+item.product_id">
				<div class="mainpro-hea" @click="natdetailsto(item.product_id)">
					<img :src="item.product_image" />
				</div>
				<div class="mainpro-foo" :class="{mainproim:true,mianproimter:item.mess1}">
					<div class="mainprofoo-hea">
						{{item.product_data_list.name}}
					</div>
					<div class="mainprofoo-foo">
						{{item.product_data_list.name_content}}
					</div>
					<div class="mainprofoo-but" @click="natdetailsto(item.product_id)" :style="'background:' + $store.state.themeColor">
						{{redirmore}}
					</div>
				</div>
			</div>
		</div>
		<el-carousel class="car-weiper" >
		    <el-carousel-item  v-for="(item,index) in videopcproduct" :key="index" class="carweiper-item">
				<div class="homecc-video">
					<div class="video-hea">
						<video   :src="item.videos" :poster="item.videos_image"></video>
						<div class="phhovideobut" @click=popvideoc(item.videos)>
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pchomeplay.svg" />
						</div>
					</div>
					<div class="video-foo">
						<div class="videofoo-hea">
							{{item.videos_title}}
						</div>
						<div class="videofoo-foo">
							{{item.videos_mark}}
						</div>
						<div class="bigprofoo-but" :style="'background:' + $store.state.themeColor">{{redirmore}}</div>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>
		<div class="homecc-conte">
			<div class="conte-create">
				<div class="create-hea">{{created}}</div>
				<div class="create-foo"  ref="testref">
					<!-- <div class="create-fooitem">
						<div class="create-itemimg">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png" />
						</div>
						<div class="create-itemhea">
							{{bird_created[0].max_title}}<span>{{oldValue}}</span>{{pometerm}}
						</div>
						<div class="create-itemfoo">
							{{bird_created[0].min_title}}<span>{{fotoldValue}}</span>{{pometerm}}
						</div>
					</div> -->
					<!-- <div class="create-fooitem">
						<div class="create-itemimg">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet2.png" />
						</div>
						<div class="create-itemhea">
							{{bird_created[1].max_title}}<span>{{leftoldValue}}</span>{{pometerm}}
						</div>
						<div class="create-itemfoo">
							{{bird_created[1].min_title}}<span>{{leftfotoldValue}}</span>{{pometerm}}
						</div>
					</div> -->
					<div class="create-fooitem">
						<div class="create-itemimg">
							<img src="../../assets/pchomeimg/pchomeadon.svg" />
						</div>
						<div class="create-itemhea">
							{{bird_created[2].max_title}}<span :style="'color:'+$store.state.themeColor">{{tacoldValue}}</span>{{pometerm}}
						</div>
						<div class="create-itemfoo">
							{{bird_created[2].min_title}}<span :style="'color:'+$store.state.themeColor">{{fottacoldValue}}</span>{{pometerm}}
						</div>
					</div>
					<div class="create-fooitem">
						<div class="create-itemimg">
							<img src="../../assets/pchomeimg/pchomeain.svg" />
						</div>
						<div class="create-itemhea">
							{{bird_created[3].max_title}}<span :style="'color:'+$store.state.themeColor">{{gighfotoldValue}}</span>{{pometerm}}
						</div>
						<div class="create-itemfoo">
							{{bird_created[3].min_title}}<span :style="'color:'+$store.state.themeColor">{{fotgighfotoldValue}}</span>{{pometerm}}
						</div>
					</div>
				</div>
			</div>
			<div class="conte-query">
				<div class="query-hea">{{anti.title}}</div>
				<div class="query-foo">{{anti.describe}}</div>
				<div class="query-seapbor">
					<div class="query-seap">
						<div class="seap-input">
							<input v-model="quersu" :placeholder="anti.tips" />
						</div>
						<div class="seap-but" @click="oponzmnqu()" :style="'background:' + $store.state.themeColor">
							{{anti.btn}}
						</div>
					</div>
				</div>
			</div>
			<div class="conte-support">
				<div class="support-hea">
					{{get_more}}
				</div>
				<div class="support-item">
					<div class="support-foo" v-for="(item,index) in more" @click="navtoae(index)">
						<div class="supportfoo-img">
							<img :src="item.img" />
						</div>
						<div class="supportfoo-title">{{item.title}}</div>
					</div>
				</div>
			</div>
		</div>
		<hpfooter></hpfooter>
	</div>
</template>

<script>
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	import hpheader from '../../common/hpheader.vue'
	import hpscorhea from '../../common/hpscorhea.vue'
	export default{
		data(){
			return{
				quersu:'',
				id:'',
				popcont:'',
				popnos:false,
				tohomevid:false,
				socrollhea:false,
				navheader:false,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				testShow:false,
				testShowbig:false,
				pometerm:'项',
				oldValue:0,
				fotoldValue:0,
				leftoldValue:0,
				leftfotoldValue:0,
				tacoldValue:0,
				fottacoldValue:0,
				gighfotoldValue:0,
				fotgighfotoldValue:0,
				pcbanimg:'',
				bigpcproductti:'',
				senpcproduct:[],
				senpcproductcont:[],
				bigpcproductticont:[],
				videopcproduct:'',
				first_product_list:"",
				is_change: 0,
				bannproid:'',
				chaece:false,
				bird_created:[],
				created_data:{}
			}
		},
		created() {
			window.scrollTo(0,0);
			
			// this.ress()
			this.pchomeprod()
			this.pageParam()
			console.log('lalalalalalalalla')
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
			
				this.$router.push({path:'./pchome'})
				return
			}
			this.ress()
		},
		mounted() {
			
			window.addEventListener("scroll", this.handleScroll)
		},
		components:{
			hpfooter,
			hpscorhea,
			hpheader
		},
		methods:{
			getimg(){
				this.chaece=true
				console.log('图片渲染完成')
			},
			pupclose(){
				this.popnos=false
			},
			natdetailsto(e){
				this.$router.push({path: '/phdetails',query:{e,type:'phone'}})
			},
			popvideoc(e){
				this.popcont=e
				this.popnos=true
			},
			navtoae(e){
				console.log(e)
				if(e==0){
					this.$router.push({path: '/phcontactus'})
				}else if(e==1){
					this.$router.push({path: '/phquerys'})
				}else if(e==2){
					this.$router.push({path: '/phcontactus'})
				}
			},
			handleScroll () {
				
			var domHight = document.body.offsetHeight;
			// dom滚动位置
			var scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			
			if(scroll!==0){
				this.socrollhea=true
			}
			// 获取监听元素
			var id;
			// 获取监听元素本身高度
			var scrollHeight;
			// 获取监听元素距离视窗顶部距离
			var offsetTop;
			// 获取监听元素距离顶部高度-窗口高度 
			this.senpcproductcont.map( (i) => {
			  id = document.getElementById(`id${i.product_id}`);
			  scrollHeight = id.scrollHeight;
			  var offsetTop = id.offsetTop;
			  // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
			  if (scroll > offsetTop - 600) {
			    
				for(let l=0;l<this.senpcproductcont.length;l++){
					if(this.senpcproductcont[l].product_id==i.product_id){
						
						this.senpcproductcont[l].mess1=true
					}
				}
			  } else {
			    
			  }
			});
			this.bigpcproductticont.map( (i) => {
				
			  id = document.getElementById(`minid${i.product_id}`);
			 let  mianscrollHeight = id.scrollHeight;
			  var mianoffsetTop = id.offsetTop;
			  // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
			  if (scroll > mianoffsetTop  - 300) {
			   
				for(let l=0;l<this.bigpcproductticont.length;l++){
					if(this.bigpcproductticont[l].product_id==i.product_id){
						
						this.bigpcproductticont[l].mess1=true
					}
				}
			  } else {
			  
			  }
			});
			let currentScroll = window.pageYOffset //表示当前滚动的位置
				
			
				 if (currentScroll >= this.$refs.testref.offsetTop - 600) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
						this.testShow = true;
						let that = this;
							let timer = setInterval(function() {
								if (that.oldValue < that.created_data.apply_inner_num) {
							        that.oldValue++;
							    } else {
							        clearInterval(timer);
							    }
							}, 15);
							let fottimer = setInterval(function() {
								if (that.fotoldValue < that.created_data.apply_inner_num_fa) {
							        that.fotoldValue++;
							    } else {
							        clearInterval(fottimer);
							    }
							}, 60);
							let lefttimer = setInterval(function() {
								if (that.leftoldValue < that.created_data.apply_out_num) {
							        that.leftoldValue++;
							    } else {
							        clearInterval(lefttimer);
							    }
							}, 265);
							let leffotttimer = setInterval(function() {
								if (that.leftfotoldValue < that.created_data.apply_out_num_fa) {
							        that.leftfotoldValue++;
							    } else {
							        clearInterval(leffotttimer);
							    }
							}, 260);
							let tactimer = setInterval(function() {
								if (that.tacoldValue < that.created_data.get_inner_num) {
							        that.tacoldValue++;
							    } else {
							        clearInterval(tactimer);
							    }
							}, 20);
							let fottactimer = setInterval(function() {
								if (that.fottacoldValue < that.created_data.get_inner_num_fa) {
							        that.fottacoldValue++;
							    } else {
							        clearInterval(fottactimer);
							    }
							}, 265);
							let righfotttimer = setInterval(function() {
								if (that.gighfotoldValue < that.created_data.get_out_num) {
							        that.gighfotoldValue++;
							    } else {
							        clearInterval(righfotttimer);
							    }
							}, 260);
							let fotrighfotttime = setInterval(function() {
								if (that.fotgighfotoldValue < that.created_data.get_out_num_fa) {
							        that.fotgighfotoldValue++;
							    } else {
							        clearInterval(fotrighfotttime);
							    }
							}, 260);
				    }
				// if (currentScroll >= this.$refs.bigprotitle.offsetTop + 600 ) { //当前滚动位置到达bigprotitle的时候，显示div（100作为调整用）
				// 	this.testShowbig=true
				//     }
			    var scrollTop =  document.documentElement.scrollTop || document.body.scrollTop
			   
				if(scrollTop!==0){
					this.navheader= true;
			
				}
			
			},
      pchomeprod(){
        let data = {
          mold: "h5",
          lang: session.get("lang") == null ? 'cn' : session.get("lang"),
          channel_id:  session.get("channel_id") == null ? 1 : session.get("channel_id"),
        }
        this.$api.goFeedback(data).then((res) => {
			console.log(res.data)
			this.pcbanimg=res.data.first_image
			this.bigpcproductti=res.data.product_data
			console.log(res.data)
			this.bigpcproductticont=[]
			this.bigpcproductti.map(((item, index)=> {
				this.bigpcproductticont.push(Object.assign({},item,{mess1:false,mess2:8}))
			}))
			this.created_data = res.data.created
			this.senpcproduct=res.data.second_data
			this.senpcproductcont=[]
			this.senpcproduct.map(((item, index)=> {
            this.senpcproductcont.push(Object.assign({},item,{mess1:false,mess2:8}))
          }))
			this.videopcproduct=res.data.videos_data
			this.first_product_list = res.data.first_product_list
			this.bannproid=res.data.first_product_id
        });
      },
			navtomore(){
				this.$router.push({path: '/phmore'})
			},
			oponzmnqu(){
				/* let af=23682052 */
				let af=this.quersu
				/* window.location.href = 'URL'; */
				window.location.href="http://cx.glwoodpecker.com.cn:88/Wp/gl?af="+af;
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
      pageParam(){
        let lang =  session.get("lang");
        if (lang === "cn"){
          this.created = "啄木鸟创造"
          this.redirmore='了解更多'
          this.pometerm='项'
          this.get_more = "获取更多支持"
          this.bird_created =  [
            {'max_title':'已申请国内专利','max_val':521,'min_title':'其中发明专利','min_val':122,'img': 'https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png'},
            {'max_title':'已获授权国内专利','max_val':254,'min_title':'其中发明授权专利','min_val':19,'img':'https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet2.png'},
            {'max_title':'已申请国际专利','max_val':13,'min_title':'其中发明专利','min_val':11,'img':'https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet3.png'},
            {'max_title':'已获授权国际专利','max_val':4,'min_title':'其中发明授权专利','min_val':2,'img':'https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet4.png'},
          ]

          this.anti = {
            title:"防伪查询",
            describe:"为了方便广大用户查询,我司于近期升级了防伪查询系统",
            tips:"请输入防伪码",
            btn:"提交"
          }
          this.more = [
              {"title":"地图定位",'img':require("../../assets/pchomeimg/pchomemap.svg")},
              {"title":"用户服务",'img':require("../../assets/pchomeimg/pchomeservice.svg")},
              {"title":"联系我们",'img':require("../../assets/pchomeimg/pccontactus.svg")},
          ]

        }else{
          this.created = "WOODPECKER CREATION"
          this.redirmore='Learn more'
          this.pometerm='term'
          this.get_more = "GET MORE SUPPORT"
          this.bird_created =  [
            {'max_title':'Applied for domestic patent','max_val':521,'min_title':'Including invention patent','min_val':122,'img':"https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png"},
            {'max_title':'Authorized domestic patent','max_val':524,'min_title':'Among them, the invention is authorized patent','min_val':19,'img':"https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png"},
            {'max_title':'International patent has been applied for','max_val':13,'min_title':'Including invention patent','min_val':11,'img':"https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png"},
            {'max_title':'Authorized international patent','max_val':4,'min_title':'Among them, the invention is authorized patent','min_val':2,'img':"https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png"},
          ]

          this.anti = {
            title:"ANTI-FAKE INQUIRY",
            describe:"For accessible checking, our anti-fake inquiry system is newly updated",
            tips:"Please input anti-fake code",
            btn:"submit"
          }

          this.more = [
              {"title":"Map",'img':require("../../assets/pchomeimg/pchomemap.svg")},
              {"title":"User Service",'img':require("../../assets/pchomeimg/pchomeservice.svg")},
              {"title":"Contact Us",'img':require("../../assets/pchomeimg/pccontactus.svg")},
           ]
        }
      },
			
		}
	}
</script>

<style>
	
	body{
		margin: 0;
		padding: 0;
	}
	.phhomecc{
		/* padding-top:  0.88rem; */
		width: 7.5rem;
		/* height: 100vh; */
		background: #FAFAFA;
		
	}
	.homecc-banner{
		width: 7.5rem;
		height: 11rem;
		position: relative;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
	}
	.banner-foo{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.babberfoo-hea{
		font-size: 0.2rem;
		font-weight: normal;
		color: #FFFFFF;
		line-height: 0.26rem;
		letter-spacing: 0.01rem;
		margin-top: 0.8rem;
	}
	.babberfoo-model{
		font-size: 0.44rem;
		font-weight: normal;
		color: #FFFFFF;
		line-height: 0.58rem;
		letter-spacing: 0.02rem;
		margin-top: 0.24rem;
	}
	.babberfoo-foo{
		font-size: 0.44rem;
		font-weight: normal;
		color: #FFFFFF;
		line-height: 0.26rem;
		letter-spacing: 0.01rem;
		margin-top: 0.24rem;
	}
	.babberfoo-but{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.46rem;
		height: 0.66rem;
		background: #E31E24;
		border-radius: 0.43rem;
		margin-top: 0.4rem;
		font-size: 0.16rem;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 0.22rem;
	}
	.homecc-bigpro{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-top: 0.8rem;
	}
	.bigpro-hea{
		width: 6.9rem;
		height: 5.2rem;
		border-radius: 0.23rem;
	}
	.bigpro-hea img{
		width: 100%;
		height: 100%;
		border-radius: 0.23rem;
	}
	.bigpro-foo{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.bigprofoo-hea{
		width: 90%;
		/* background: red; */
		text-align: center;
		font-size: 0.2rem;
		font-weight: normal;
		color: #5d5f5f;
		line-height: 0.26rem;
		letter-spacing: 0.01rem;
		/*margin-top: 1.41rem;*/
	}
	.bigprofoo-model{
		font-size: 0.44rem;
		font-weight: normal;
		color: #5d5f5f;
		line-height: 0.58rem;
		letter-spacing: 0.02rem;
		margin-top: 0.24rem;
	}
	.bigprofoo-foo{
		font-size: 0.2rem;
		font-weight: normal;
		color: #5d5f5f;
		line-height: 0.26rem;
		letter-spacing: 0.01rem;
		margin-top: 0.24rem;
	}
	.bigprofoo-but{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.46rem;
		height: 0.66rem;
		background: #E31E24;
		border-radius: 0.43rem;
		margin-top: 0.4rem;
		font-size: 0.16rem;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 0.22rem;
	}
	
	
	.homecc-mainpro{
		display: flex;
		flex-wrap: wrap;
		margin-top: 0.8rem;
		padding-left: 0.3rem;
		box-sizing: border-box;
	}
	.mainpro-hea{
		width: 3.3rem;
		height: 2.45rem;
		border-radius: 0.23rem 0.23rem 0 0 ;
	}
	.mainpro-hea img{
		width: 100%;
		height: 100%;
		border-radius: 0.23rem 0.23rem 0 0 ;
	}
	.mainpro-foo{
		padding-left: 0.2rem;
		box-sizing: border-box;
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	.mainprofoo-hea{
		min-height: 0.8rem;
		font-size: 0.28rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-top: 0.21rem;
	}
	
	.mainprofoo-foo{
		font-size: 0.2rem;
		font-weight: 400;
		color: #666666;
		line-height: 0.28rem;
		letter-spacing: 0.01rem;
		margin-top: 0.12rem;
		min-height: 0.8rem;
		
	}
	.mainprofoo-but{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.46rem;
		height: 0.66rem;
		background: #E31E24;
		border-radius: 0.43rem;
		margin-top: 0.2rem;
		font-size: 0.16rem;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 0.22rem;
	}
	.mainpro-item{
		width: 3.3rem;
		background-color: #FFFFFF;
		margin-right: 0.3rem;
		border-radius: 0.23rem;
		margin-bottom: 0.3rem;
		padding-bottom: 0.3rem;
	}
	.mainpro-item:nth-child(2n){
		margin-right: 0rem;
	}
	.homecc-video{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		margin-top: 0.8rem;
	}
	.video-hea{
		width: 6.9rem;
		height: 3.88rem;
		border-radius: 0.23rem;
		position: relative;
	}
	.video-hea video{
		width: 100%;
		height: 100%;
		border-radius: 0.23rem;
	}
	.phhovideobut {
		width: 6.9rem;
		height: 3.88rem;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
		
	}
	.phhovideobut img{
		/* background-color: #fff; */
		width: 0.9rem;
		height: 0.9rem;
	}
	.video-foo{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.videofoo-hea{
		font-size: 0.44rem;
		font-weight: normal;
		color: #5d5f5f;
		line-height: 0.58rem;
		letter-spacing: 0.02rem;
		margin-top: 0.4rem;
	}
	.videofoo-foo{
		font-size: 0.2rem;
		font-weight: normal;
		color: #5d5f5f;
		line-height: 0.26rem;
		letter-spacing: 0.01rem;
		margin-top: 0.24rem;
		margin-left: 0.3rem;
	}
	.homecc-conte{
		background-color: #FFFFFF;
	}
	.conte-create{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.create-hea{
		font-size: 0.4rem;
		font-weight: 600;
		color: #5d5f5f;
		line-height: 0.56rem;
		letter-spacing: 0.02rem;
		margin-top: 0.6rem;
	}
	.create-foo{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		margin-top: 0.6rem;
	}
	.create-fooitem{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-right: 1.13rem;
		width: 2.8rem;
	}
	.create-fooitem:nth-child(2n){
		margin-right: 0rem;
	}
	.create-itemimg{
		width: 0.9rem;
		height: 0.9rem;
	}
	
	.create-itemimg img{
		width: 100%;
		height: 100%;
	}
	.create-itemhea{
		font-size: 0.24rem;
		font-weight: 400;
		color: #5d5f5f;
		line-height: 0.34rem;
		letter-spacing: 0.01rem;
		margin-top: 0.24rem;
	}
	.create-itemhea span{
		color: #E31E24;
	}
	.create-fooitem{
		
		font-size: 0.2rem;
		font-weight: 400;
		color: #666666;
		line-height: 0.28rem;
		letter-spacing: 0.01rem;
		margin-top: 0.14rem;
	}
	.create-fooitem span{
		color: #E31E24;
	}
	.conte-query{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.query-hea{
		font-size: 0.4rem;
		font-weight: 600;
		color: #5d5f5f;
		line-height: 0.56rem;
		letter-spacing: 0.02rem;
		margin-top: 0.8rem;
	}
	.query-foo{
		font-size: 0.2rem;
		font-weight: 400;
		color: #666666;
		line-height: 0.28rem;
		letter-spacing: 0.01rem;
		margin-top: 0.2rem;
		margin-left: 0.3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}
	.query-seapbor{
		margin-top: 0.4rem;
		background-color: #cccc;
		width: 6.9rem;
		height: 0.7rem;
		padding: 0.01rem;
		border-radius: 0.35rem;
	}
	.query-seap{
		
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 6.9rem;
		height: 0.7rem;
		background: #FFFFFF;
		border-radius: 0.35rem;
		/* border: 0.01rem solid #CCCCCC; */
	}
	.seap-input{
		width: 5rem;
		height: 0.6rem;
		border-radius: 0.3rem;
		margin-left: 0.27rem;
		display: flex;
	}
	.seap-input input{
		border: none;
		width: 5rem;
		height: 0.5rem;
		outline: none;
		border-radius: 0.3rem;
		display: flex;
	}
	.seap-but{
		width: 1.1rem;
		height: 0.46rem;
		background: #E31E24;
		border-radius: 0.23rem;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.16rem;
		font-weight: 400;
		color: #FFFFFF;
		margin-right: 0.07rem;
	}
	.conte-support{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.support-hea{
		font-size: 0.4rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.02rem;
		margin-top: 0.8rem;
	}
	.support-item{
		font-size: 0.2rem;
		display: flex;
		margin-top: 0.6rem;
		padding: 0 0.3rem;
		margin-bottom: 0.8rem;
		/* margin-left: 0.3rem;
		margin-right: 0.3rem; */
	}
	.support-foo{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		
		margin-left: 1.00rem;
	}
	.support-foo:first-child{
		margin-left: 0rem;
	}
	
	.checse{
		position: absolute;
		margin-top: 1.41rem;
		-webkit-animation-name: "fadeInLeft"; /*动画名称，需要跟@keyframes定义的名称一致*/
		-webkit-animation-duration: 1s;/*动画持续的时间长*/
		-webkit-animation-iteration-count: 1;/*动画循环播放的次数为1 infinite为无限次*/
	}
	.car-weiper{
		height: 8.8rem;
		margin-top: 0.4rem;
		background: #FFFFFF;
	}
	.carweiper-item{
		height: 8.8rem;
		background: #FFFFFF;
	}
	.swiper-cont{
		height: 8.8rem;
		display: flex;
		flex-direction: column;
	}
	.el-carousel__indicators--horizontal{
		display: none;
	}
	.bannerimg{
		position: absolute;
		top: 0;
		left: 0;
		width: 7.5rem;
		height: 11rem;
	}
	.bannerimg img{
		width: 100%;
		height: 100%;
	}
	.bigproimter{
		transform: translateX(0%) !important;
		opacity: 1 !important;
		transition: all 1s ease;
		width: 100%;
	}
	.bigproim{
		transform: translateX(-50%);
		opacity: 0;
	}
	.mianproimter{
		transform: translateY(0%) !important;
		opacity: 1 !important;
		transition: all 0.75s ease;
	}
	.mainproim{
		transform: translateY(10%);
		opacity: 0;
	}
	.videopop{
		
	}
	.videopopcont{
		width: 100vw;
		height: 100vh;
		background: rgba(0,0,0,.38);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: center;
		
	}
	.videopopcont{
		
		/* position: relative; */
	}
	.videopopcont video{
		width: 100vw;
		height: 4.2rem;
	}
	.closevi{
		font-size: 0.5rem;
		color: #fff;
		position: absolute;
		top: 4.2rem;
		right: -0.1rem;
		z-index: 99;
	}
	.supportfoo-title {
		color: #5d5f5f;
	}
</style>
